import { getCurrentSession, getSessionSlug } from 'src/state/restoreLocation';

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/';

const session = getCurrentSession();
const ROOTS_DASHBOARD = session ? `/${getSessionSlug(session)}` : '';

// @deprecated - use routes instead
export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, 'login'),
  register: path(ROOTS_AUTH, 'register'),
  forgotPassword: path(ROOTS_AUTH, 'forgot-password'),
  resetPassword: path(ROOTS_AUTH, 'reset-password'),
  verifyAccount: path(ROOTS_AUTH, 'verify-email'),
  twoFactor: path(ROOTS_AUTH, 'two-factor'),

  needChangePassword: path(ROOTS_AUTH, 'need-change-password'),
  needEnableTwoFactor: path(ROOTS_AUTH, 'need-enable-two-factor'),
};

// @deprecated - use routes instead
export const PATH_WIZARD = {
  root: path(ROOTS_AUTH, 'wizard'),
  createWorkspace: path(ROOTS_AUTH, 'wizard/new'),
};

// @deprecated - use routes instead
export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

// @deprecated - use routes instead
export const PATH_DASHBOARD = {
  root: path(ROOTS_DASHBOARD, '/chat'),

  wizard: {
    inviteSlug: (accountIndex: string) =>
      path(`/${accountIndex}`, '/wizard/invite'),
    invite: path(ROOTS_DASHBOARD, '/wizard/invite'),
    selectPlan: path(ROOTS_DASHBOARD, '/wizard/plans'),
    paymentPlan: (query: string = '') =>
      path(ROOTS_DASHBOARD, `/wizard/payment${query}`),
  },

  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/chat/${id}`),
    newThread: (id: string, parentMessageId: string) =>
      path(ROOTS_DASHBOARD, `/chat/${id}/new-thread/${parentMessageId}`),
    thread: (id: string, threadId: string) =>
      path(ROOTS_DASHBOARD, `/chat/${id}/thread/${threadId}`),
    subchannel: (id: string, subchannel: string) =>
      path(ROOTS_DASHBOARD, `/chat/${id}/subchannel/${subchannel}`),
  },
  board: {
    root: path(ROOTS_DASHBOARD, '/boards'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/boards/${id}`),
    table: ({ boardId, tableId }: { boardId: string; tableId: string }) =>
      path(ROOTS_DASHBOARD, `/boards/${boardId}/${tableId}`),
    tableView: ({
      boardId,
      tableId,
      viewId,
    }: {
      boardId: string;
      tableId: string;
      viewId: string;
    }) => path(ROOTS_DASHBOARD, `/boards/${boardId}/${tableId}/${viewId}`),
    rowDialog: ({
      board,
      row,
      table,
    }: { board: string; row: string; table: string }) =>
      path(ROOTS_DASHBOARD, `/boards/${board}/${table}/v/${row}`),
  },
  todo: {
    root: path(ROOTS_DASHBOARD, '/todo'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/todo/${id}`),
    zen: (todoId: string) => path(ROOTS_DASHBOARD, `/zen/todo/${todoId}`),
  },
  docs: {
    root: path(ROOTS_DASHBOARD, '/docs'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/docs/${id}`),
    comments: (id: string) => path(ROOTS_DASHBOARD, `/docs/${id}/comments`),
    trash: path(ROOTS_DASHBOARD, '/docs/trash'),
    publicDoc: (token: string, childToken?: string) =>
      `/public-doc/${token}${childToken ? `/${childToken}` : ''}`,
  },
  ai: {
    root: path(ROOTS_DASHBOARD, '/ai'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/ai/${id}`),
    schedules: path(ROOTS_DASHBOARD, '/ai/schedule'),
    scheduleView: (id: string) => path(ROOTS_DASHBOARD, `/ai/schedule/${id}`),
  },
  drive: {
    root: path(ROOTS_DASHBOARD, '/drive/f'),
    folder: (id: string) => path(ROOTS_DASHBOARD, `/drive/f/${id}`),
    allfiles: path(ROOTS_DASHBOARD, `/drive/all-files`),
    recent: path(ROOTS_DASHBOARD, `/drive/recent`),
    shared: path(ROOTS_DASHBOARD, `/drive/shared-with-me`),
    starred: path(ROOTS_DASHBOARD, `/drive/starred`),
    trash: path(ROOTS_DASHBOARD, `/drive/trash`),
  },

  kanban: path(ROOTS_DASHBOARD, '/kanban'),

  fileManager: path(ROOTS_DASHBOARD, '/files-manager'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    general: path(ROOTS_DASHBOARD, '/general'),

    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    file: path(ROOTS_DASHBOARD, '/file'),
  },

  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name: string) =>
      path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name: string) =>
      path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(
      ROOTS_DASHBOARD,
      '/e-commerce/product/nike-blazer-low-77-vintage/edit',
    ),
    demoView: path(
      ROOTS_DASHBOARD,
      '/e-commerce/product/nike-air-force-1-ndestrukt',
    ),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(
      ROOTS_DASHBOARD,
      '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit',
    ),
    demoView: path(
      ROOTS_DASHBOARD,
      '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5',
    ),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title: string) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(
      ROOTS_DASHBOARD,
      '/blog/post/apply-these-7-secret-techniques-to-improve-event',
    ),
  },
};

// @deprecated - use routes instead
export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};

// @deprecated - use routes instead
export const PATH_ZONE_ON_STORE =
  'https://mui.com/store/items/zone-landing-page/';

// @deprecated - use routes instead
export const PATH_MINIMAL_ON_STORE =
  'https://mui.com/store/items/minimal-dashboard/';

// @deprecated - use routes instead
export const PATH_FREE_VERSION =
  'https://mui.com/store/items/minimal-dashboard-free/';

// @deprecated - use routes instead
export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1';

// @deprecated - use routes instead
export const PATH_SETTINGS = {
  workspace: {
    general: path(ROOTS_DASHBOARD, '/settings/workspace/general'),
    billing: path(ROOTS_DASHBOARD, '/settings/workspace/billing'),
    members: path(ROOTS_DASHBOARD, '/settings/workspace/members'),
    security: path(ROOTS_DASHBOARD, '/settings/workspace/security'),
    teams: path(ROOTS_DASHBOARD, '/settings/workspace/teams'),
    roles: path(ROOTS_DASHBOARD, '/settings/workspace/roles'),
    subscription: path(ROOTS_DASHBOARD, '/settings/workspace/subscription'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/settings/user'),
    account: path(ROOTS_DASHBOARD, '/settings/user/account'),
    language: path(ROOTS_DASHBOARD, '/settings/user/language'),
    security: path(ROOTS_DASHBOARD, '/settings/user/security'),
    notifications: path(ROOTS_DASHBOARD, '/settings/user/notifications'),
  },
};

export const PATH_AFTER_LOGIN = '/signed-in';

export const routes = {
  root: ROOTS_AUTH,
  auth: PATH_AUTH,
  dashboard: PATH_DASHBOARD,
  docs: PATH_DOCS,
  wizard: PATH_WIZARD,
  settings: PATH_SETTINGS,
  ...PATH_PAGE,
};
